import styled from 'styled-components';

export default styled.div`
  border-radius: 15px;
  border: 1px solid var(--white);
  background: color-mix(in srgb, var(--white) 25%, transparent);
`;
